//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

/* Imports */
var Tracker = Package.tracker.Tracker;
var Deps = Package.tracker.Deps;



/* Exports */
if (typeof Package === 'undefined') Package = {};
(function (pkg, symbols) {
  for (var s in symbols)
    (s in pkg) || (pkg[s] = symbols[s]);
})(Package.deps = {}, {
  Tracker: Tracker,
  Deps: Deps
});

})();



/*****************
 ** WEBPACK FOOTER
 ** ./build/meteor/bundle/programs/web.browser/packages/deps.js
 ** module id = ./build/meteor/bundle/programs/web.browser/packages/deps.js
 ** module chunks = 0 1
 **/